// /client/src/components/AdminLayout.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  AppBar, Toolbar, Typography, Button, Box, Drawer, List, ListItem,
  ListItemButton, ListItemIcon, ListItemText
} from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import BuildIcon from '@mui/icons-material/Build';
import { useAuth } from '../context/AuthContext';

const drawerWidth = 240;

const AdminLayout = ({ children }) => {
  const { logout } = useAuth();

  // --- THIS IS THE FIX ---
  // The paths now correctly match the routes defined in App.js
  const navItems = [
    { text: 'Projects', icon: <FolderIcon />, path: '/admin/dashboard/projects' },
    { text: 'Skills', icon: <BuildIcon />, path: '/admin/dashboard/skills' },
  ];

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Top App Bar */}
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Portfolio CMS
          </Typography>
          <Button color="inherit" onClick={logout}>Logout</Button>
        </Toolbar>
      </AppBar>

      {/* Side Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
        }}
      >
        <Toolbar /> {/* Spacer for AppBar */}
        <Box sx={{ overflow: 'auto' }}>
          <List>
            {navItems.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton component={NavLink} to={item.path}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, mt: '64px' }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default AdminLayout;